<template>
  <form @submit.prevent class="m-searchform__filter">

    <div class="row">

      <div class="item">
        <input v-model="search.keyword"
          :aria-label="$t('action.search')" :placeholder="$t('action.search')"
          type="text" class="m-searchform__input -round-corner cx-field"
        >
        <i class="fas fa-search"></i>
      </div>

      <div v-if="sightFilters && tab === 'sight'" class="item">
        <rich-search-select
          icon="fas fa-fw fa-tag"
          :name="$t('common.type')"
          :options="sightFilters"
          :selectedOption.sync="search.sightCategory"
        ></rich-search-select>
      </div>

      <div v-if="restaurantFilters && tab === 'restaurant'" class="item">
        <rich-search-select
          icon="fas fa-fw fa-tag"
          :name="$t('dining.anyCategory')"
          :options="restaurantFilters"
          :selectedOption.sync="search.restaurantCategory"
        ></rich-search-select>
      </div>

      <div v-if="accommodationFilters && tab === 'hotel'" class="item">
        <rich-search-select
          icon="fas fa-star"
          :name="$t('accommodation.anyStar')"
          :options="accommodationFilters"
          :selectedOption.sync="search.star"
        ></rich-search-select>
      </div>

    </div>
  </form>
</template>

<script>
import axios from 'axios';
import RichSearchSelect from '@/components/RichSearchSelect';

export default {
  name: 'accessibility-search-form',
  components: {
    RichSearchSelect,
  },
  data() {
    return {
      presetOptions: {},
      search: {
        keyword: '',
        sightCategory: '',
        restaurantCategory: '',
        star: '',
      },
      timer: null,
    };
  },
  props: {
    tab: {
      type: String,
      default() {
        return '';
      },
    },
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    sightFilters() {
      return this.settings.categories.sights.map(this.formation);
    },
    restaurantFilters() {
      return this.settings.categories.restaurants.map(this.formation);
    },
    accommodationFilters() {
      return this.settings.categories.hotels.map(this.formation);
    },
  },
  watch: {
    tab(tab) {
      const duplicate = Object.assign(this.search, {
        keyword: '',
        sightCategory: '',
        restaurantCategory: '',
        star: '',
      });

      this.search = Object.assign({}, duplicate);
    },
    search: {
      deep: true,
      handler(value) {
        if (this.timer) {
          window.clearTimeout(this.timer);
        }

        this.timer = window.setTimeout(this.updateParents, 100);
      },
    },
  },
  methods: {
    updateParents() {
      const duplicate = Object.assign({}, this.search);
      duplicate.keyword = this.search.keyword.trim();
      this.$emit('update-search', duplicate);
    },
    formation(data) {
      return { name: data, value: data };
    },
  },
};
</script>

<style lang="scss" scoped>
form.m-searchform__filter {
  margin-top: 0 !important;

  .m-searchform__input.cx-field {
    padding-left: 43px;
  }

  i.fas {
    position: absolute;
    top: 22px;
    left: 22.6px;

    @media (max-width: $breakpoint-md) {
      top: 20px;
      left: 26px;
    }
  }
}

.row {
  display: flex;
  margin: -8px -8px 0;

  @media (max-width: $breakpoint-sm) {
    flex-direction: column;
  }

  .item {
    width: 33.33%;
    flex: 1 0 33.33%;
    padding: 0 8px;
    position: relative;

    @media (max-width: $breakpoint-sm) {
      width: 100%;
      flex: 1 0 100%;
    }
  }
}
  
</style>
